import { render, staticRenderFns } from "./IncidentCategoryHistory.vue?vue&type=template&id=fb878974&"
import script from "./IncidentCategoryHistory.vue?vue&type=script&lang=js&"
export * from "./IncidentCategoryHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports